export type OrCardVariant = "content" | "feature" | "shortcut" | "summary";

export interface UseOrCardParams {
  className?: string;
  primaryValue?: number;
  secondaryValue?: number;
  variant: OrCardVariant;
}

export interface UseOrCardResult {
  cardClassName: string;
  circumference: number;
  primaryPercent: number;
  primaryStroke: number;
  secondaryStroke: number;
}

function clampPercentage(value: number): number {
  if (value < 0) {
    return 0;
  }

  if (value > 100) {
    return 100;
  }

  return value;
}

export function useOrCard({
  className,
  primaryValue = 0,
  secondaryValue = 0,
  variant,
}: UseOrCardParams): UseOrCardResult {
  const total = primaryValue + secondaryValue;
  const primaryPercent = total > 0 ? clampPercentage((primaryValue / total) * 100) : 0;
  const circumference = 2 * Math.PI * 65;
  const primaryStroke = (circumference * primaryPercent) / 100;
  const secondaryStroke = total > 0 ? circumference - primaryStroke : 0;

  const cardClassName = ["or-card", `or-card--${variant}`, className ?? ""].filter(Boolean).join(" ");

  return {
    cardClassName,
    circumference,
    primaryPercent,
    primaryStroke,
    secondaryStroke,
  };
}
